function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import React from 'react';
import PropTypes from 'prop-types';
import defaultProps from '../default-props';
var UndrawInSync = function UndrawInSync(_props) {
  var props = Object.assign({}, _props);
  var primaryColor = props.primaryColor || defaultProps.primaryColor;
  var style = Object.assign({
    height: props.height || defaultProps.height,
    width: '100%'
  }, props.style);
  delete props.primaryColor;
  delete props.height;
  delete props.style;
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: "1em",
    height: "1em",
    viewBox: "0 0 1086.82 789.35",
    style: style
  }, props), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "prefix__a",
    x1: 687.58,
    y1: 652.36,
    x2: 687.58,
    y2: 167.98,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), React.createElement("linearGradient", {
    id: "prefix__b",
    x1: 357.66,
    y1: 752.53,
    x2: 357.66,
    y2: 310.18,
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__c",
    x1: 211.31,
    y1: 788.29,
    x2: 211.31,
    y2: 442.62,
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__d",
    x1: 462.24,
    y1: 798.83,
    x2: 462.24,
    y2: 605.67,
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__e",
    x1: 382.57,
    y1: 625.81,
    x2: 473.48,
    y2: 625.81,
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__f",
    x1: 513.42,
    y1: 844.47,
    x2: 513.42,
    y2: 415.5,
    gradientTransform: "matrix(-1 0 0 1 825.97 0)",
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__g",
    x1: 203.72,
    y1: 516.5,
    x2: 203.72,
    y2: 437.56,
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__h",
    x1: 1061.94,
    y1: 708.58,
    x2: 1061.94,
    y2: 289.15,
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__i",
    x1: 917.3,
    y1: 444.63,
    x2: 917.3,
    y2: 300.43,
    xlinkHref: "#prefix__a"
  })), React.createElement("path", {
    d: "M153.41 43.62c-8.06-.23-16.32 0-23.88 2.32-20.57 6.32-30.32 27-27.15 44.87s16.21 33.44 29.74 47.67 28.19 28.3 35.61 45.31c3.7 8.49 5.43 18 1.67 26.48-5.8 13.07-23.29 20.37-40.08 21.89s-33.65-1.44-50.5-2.43c-7.07-.41-14.34-.46-21 1.45-7.31 2.08-13.4 6.33-19 10.76C16.93 259.3-.59 283.01 2.27 307.88c3.2 28.23 31.74 50.54 63 62.51 10.35 4 21.3 7.18 30.41 12.84 24 14.93 29.39 42.93 27 67.64s-10.53 49.45-6 73.94c5.33 28.49 28.92 54.23 60.74 66.25 28.35 10.71 63.83 10 89-5.11 12.27-7.38 21.55-17.63 29.62-28.23a227.74 227.74 0 0 0 29.45-51c3.51-8.49 6.81-17.62 15-23.52 5-3.63 11.48-5.66 17.89-7.24 19.32-4.76 39.67-6.06 59.17-10.3s39.07-12.15 49.67-26.28c15-20 8-45.62 8.07-69.14.12-53.66 39.11-101.69 53.5-154 4.7-17.09 6.45-36-4.05-51.25-7.13-10.35-19.16-17.82-31.8-23.59-27.81-12.69-59.42-18.34-90.51-23.84-43.21-7.64-95.68-8.63-129.17-33.35-32.09-23.68-76.06-40.59-119.85-40.59z",
    fill: primaryColor,
    opacity: 0.2
  }), React.createElement("g", {
    opacity: 0.5
  }, React.createElement("path", {
    d: "M27.34 349.35c-2.14 3.16-3.9 7.75-1.1 13.1 5.5 10.5 19.1 8.34 25.71 18.39a18.38 18.38 0 0 1 2.85 9.29c.25 5.69-1.51 10.17-2.42 15.18A25.66 25.66 0 0 0 55 422.65a30.62 30.62 0 0 0 14 12.49c5.12 2.26 10 2.84 14.9 3.94a91.71 91.71 0 0 1 17.67 6 33.36 33.36 0 0 1 7.54 4.4 54.91 54.91 0 0 1 7.63 8.22l21.27 26.26a75.18 75.18 0 0 0 9 9.84 54.21 54.21 0 0 0 11.72 7.21c8.49 4.23 17.37 8.56 24.74 8.07s12.49-7.6 9-17.54c-3.3-9.46-12.6-17.43-16.82-26.87-6.65-14.88 2.06-26-3.51-40.9-5.34-14.32-20.31-23.92-29.87-37-6.86-9.3-10.68-20.12-16.86-29.89-9-14-22.4-24.71-35-30.13a67.93 67.93 0 0 0-35.16-4.87c-4.56.5-9.05 1.35-12.29 4.08-3.44 2.9-3 8.32-5.24 12.17-2.57 4.43-7.47 6.94-10.38 11.22z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M40.69 329.21s106.48 99.55 149.42 177.06M26.65 363.06s42.55-8.27 72 24.9M56.89 425.57s47-32.87 63.26-13.75M90.21 326.51s-4.95 25.16 12.86 66.26M172.09 424.16s-4.16 16.5-37.6 4.37M138.14 481.88s20.41-23.59 11.13-35.17",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), React.createElement("path", {
    d: "M7.33 233.88c-5 5.91-9.68 14.09-6 22.16 7.08 15.84 33.29 8.09 42.64 22.84 2.8 4.41 3.18 9.8 2.53 14.61-1.26 9.41-5.92 17.4-9.14 26s-4.89 19-.35 28.08c4.37 8.79 13.58 14.34 22.5 16.55s17.86 1.71 26.77 2a148.2 148.2 0 0 1 31.35 4.62 43.31 43.31 0 0 1 12.78 5.14c4.55 2.91 8.23 7.18 11.83 11.38l32 37.29c4.25 5 8.59 10 13.86 13.67 6.08 4.23 13 6.38 19.81 8.45 14.65 4.48 30 9 44 5.93s25.75-16.45 22.25-31.94c-3.33-14.75-18.35-25.21-23.41-39.66-8-22.77 11.75-43.89 5.82-67.06-5.68-22.22-30.86-33.68-44.86-52.49-10-13.48-13.94-30.34-22.68-44.68-12.62-20.7-34.62-34.41-56.52-39.62s-43.93-2.78-64.47 2.43c-8.7 2.21-17.4 5-24.3 10.52-7.33 5.87-8.17 14.78-13.51 21.86-6.19 8.23-16.16 13.92-22.9 21.92z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M38.48 196.28s169.67 133.5 226.76 249.6M1.87 256.88s82.37-26.65 127.54 19.66M39.67 351.88s98.11-69 122.91-42.09M132.26 176.76s-16.91 43.39 4 106.46M256.31 314.57s-12.81 28.73-71.9 18.68M175.1 420.98s45.47-45.48 31.57-62",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), React.createElement("ellipse", {
    cx: 617.97,
    cy: 647.16,
    rx: 465,
    ry: 124.52,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M980.15.41s-35.83 35.83-15.6 89S929.87 231 929.87 231s.59-.09 1.68-.28c73.59-13 110.16-97.16 69.24-159.69-15.21-23.24-27.7-50.5-20.64-70.62z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M980.15.41s-20.23 43.92 0 79.75 3.47 136.39-50.28 150.84",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), React.createElement("path", {
    d: "M1043.97 145.34s-40.89-6.51-44.61 30.13-78.62 41.72-78.62 41.72l1.4.93c61.84 40.59 121 25.86 112-28-3.27-20.08-3-40.24 9.83-44.78z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M1043.97 145.34s-40.89-6.51-44.61 30.13-78.62 41.72-78.62 41.72l1.4.93c61.84 40.59 121 25.86 112-28-3.27-20.08-3-40.24 9.83-44.78z",
    fill: "#f5f5f5",
    opacity: 0.2
  }), React.createElement("path", {
    d: "M1043.97 145.34s-31.74 7-29.13 35.82-47.13 63.45-94.1 36M246.7 279.8s-13.26-45 2.49-78.14a71.09 71.09 0 0 0 5.75-44.6 119.57 119.57 0 0 0-6.31-20.93",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), React.createElement("path", {
    d: "M258.41 115.18c0 5.52-10 21.51-10 21.51s-10-16-10-21.51a10 10 0 1 1 20 0zM274.93 145.74c-3 4.63-20.08 12.63-20.08 12.63s.31-18.86 3.31-23.49a10 10 0 1 1 16.77 10.86zM274.21 197.96c-4.93 2.48-23.71.77-23.71.77s9.79-16.12 14.71-18.6a10 10 0 1 1 9 17.84zM264.77 237.34c-4.44 3.28-23.24 4.76-23.24 4.76s6.92-17.54 11.36-20.82a10 10 0 1 1 11.88 16.06zM233.88 159.44c4 3.84 22.39 7.83 22.39 7.83s-4.51-18.31-8.47-22.15a10 10 0 1 0-13.92 14.33zM223.41 205.64c4.93 2.48 23.71.77 23.71.77s-9.79-16.12-14.71-18.6a10 10 0 0 0-9 17.84zM219.41 251.94c4.44 3.28 23.24 4.76 23.24 4.76s-6.92-17.54-11.36-20.82a10 10 0 0 0-11.88 16.06z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M1129 596.62h-85.09a28.36 28.36 0 0 0 3-12.67V196.47a28.49 28.49 0 0 0-28.49-28.47H359.75a28.49 28.49 0 0 0-28.49 28.49v387.46a28.36 28.36 0 0 0 3 12.67h-88.1a7.53 7.53 0 0 0-7.53 7.53v6.07a42.14 42.14 0 0 0 42.14 42.14h813.68a42.14 42.14 0 0 0 42.14-42.14v-6.07a7.53 7.53 0 0 0-7.59-7.53zm-524.29 24.1l-7.3-8.29h181.11l-8.08 8.29z",
    transform: "translate(-56.59 -55.12)",
    fill: "url(#prefix__a)"
  }), React.createElement("rect", {
    x: 282.74,
    y: 118.35,
    width: 699.44,
    height: 434.39,
    rx: 23.26,
    ry: 23.26,
    fill: "#535461"
  }), React.createElement("path", {
    fill: "#f1f1f4",
    d: "M297.47 181.67h668.52v354.87H297.47z"
  }), React.createElement("circle", {
    cx: 631.73,
    cy: 150.74,
    r: 5.89,
    fill: "#fff"
  }), React.createElement("path", {
    d: "M734.95 537.27l-23 23.56h-162l-20.76-23.56H199.54a7.36 7.36 0 0 0-7.36 7.36v5.94a41.18 41.18 0 0 0 41.23 41.18h795.2a41.18 41.18 0 0 0 41.18-41.18v-5.94a7.36 7.36 0 0 0-7.36-7.36z",
    fill: "#535461"
  }), React.createElement("path", {
    fill: "#fff",
    d: "M338.3 208.71h182.77v137.74H338.3z"
  }), React.createElement("path", {
    fill: primaryColor,
    opacity: 0.2,
    d: "M356.18 220.63h60.92v34.43h-60.92z"
  }), React.createElement("path", {
    fill: "#e6e8ec",
    d: "M431.67 220.63h71.52v7.95h-71.52zM431.67 233.87H482v7.95h-50.33zM431.67 247.11h71.52v7.95h-71.52zM356.18 260.36h147.01v7.95H356.18zM356.18 273.6h147.01v7.95H356.18zM356.18 286.85h147.01v7.95H356.18zM356.18 300.09h135.09v7.95H356.18zM356.18 313.33h147.01v7.95H356.18zM356.18 326.58h147.01v7.95H356.18z"
  }), React.createElement("path", {
    fill: "#fff",
    d: "M539.61 208.71h182.77v137.74H539.61z"
  }), React.createElement("path", {
    fill: primaryColor,
    opacity: 0.2,
    d: "M557.48 220.63h60.92v34.43h-60.92z"
  }), React.createElement("path", {
    fill: "#e6e8ec",
    d: "M632.98 220.63h71.52v7.95h-71.52zM632.98 233.87h50.33v7.95h-50.33zM632.98 247.11h71.52v7.95h-71.52zM557.48 260.36h147.01v7.95H557.48zM557.48 273.6h147.01v7.95H557.48zM557.48 286.85h147.01v7.95H557.48zM557.48 300.09h135.09v7.95H557.48zM557.48 313.33h147.01v7.95H557.48zM557.48 326.58h147.01v7.95H557.48z"
  }), React.createElement("path", {
    fill: "#fff",
    d: "M740.91 208.71h182.77v137.74H740.91z"
  }), React.createElement("path", {
    fill: primaryColor,
    opacity: 0.2,
    d: "M758.79 220.63h60.92v34.43h-60.92z"
  }), React.createElement("path", {
    fill: "#e6e8ec",
    d: "M834.28 220.63h71.52v7.95h-71.52zM834.28 233.87h50.33v7.95h-50.33zM834.28 247.11h71.52v7.95h-71.52zM758.79 260.36H905.8v7.95H758.79zM758.79 273.6H905.8v7.95H758.79zM758.79 286.85H905.8v7.95H758.79zM758.79 300.09h135.09v7.95H758.79zM758.79 313.33H905.8v7.95H758.79zM758.79 326.58H905.8v7.95H758.79z"
  }), React.createElement("path", {
    fill: "#fff",
    d: "M338.3 363.66h182.77V501.4H338.3z"
  }), React.createElement("path", {
    fill: primaryColor,
    opacity: 0.2,
    d: "M356.18 375.58h60.92v34.43h-60.92z"
  }), React.createElement("path", {
    fill: "#e6e8ec",
    d: "M431.67 375.58h71.52v7.95h-71.52zM431.67 388.83H482v7.95h-50.33zM431.67 402.07h71.52v7.95h-71.52zM356.18 415.31h147.01v7.95H356.18zM356.18 428.56h147.01v7.95H356.18zM356.18 441.8h147.01v7.95H356.18zM356.18 455.05h135.09V463H356.18zM356.18 468.29h147.01v7.95H356.18zM356.18 481.53h147.01v7.95H356.18z"
  }), React.createElement("path", {
    fill: "#fff",
    d: "M539.61 363.66h182.77V501.4H539.61z"
  }), React.createElement("path", {
    fill: primaryColor,
    opacity: 0.2,
    d: "M557.48 375.58h60.92v34.43h-60.92z"
  }), React.createElement("path", {
    fill: "#e6e8ec",
    d: "M632.98 375.58h71.52v7.95h-71.52zM632.98 388.83h50.33v7.95h-50.33zM632.98 402.07h71.52v7.95h-71.52zM557.48 415.31h147.01v7.95H557.48zM557.48 428.56h147.01v7.95H557.48zM557.48 441.8h147.01v7.95H557.48zM557.48 455.05h135.09V463H557.48zM557.48 468.29h147.01v7.95H557.48zM557.48 481.53h147.01v7.95H557.48z"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M740.91 363.66h182.77V501.4H740.91z"
  }), React.createElement("path", {
    d: "M498.66 310.18h-282A25.83 25.83 0 0 0 190.78 336v390.74a25.83 25.83 0 0 0 25.87 25.8h282a25.83 25.83 0 0 0 25.87-25.8V336a25.83 25.83 0 0 0-25.86-25.82z",
    transform: "translate(-56.59 -55.12)",
    fill: "url(#prefix__b)"
  }), React.createElement("rect", {
    x: 138.17,
    y: 260.36,
    width: 325.8,
    height: 433.08,
    rx: 20,
    ry: 20,
    fill: "#535461"
  }), React.createElement("path", {
    fill: "#f1f1f4",
    d: "M154.72 301.33h292.69v351.15H154.72z"
  }), React.createElement("circle", {
    cx: 299.74,
    cy: 280.23,
    r: 3.97,
    fill: "#fff"
  }), React.createElement("circle", {
    cx: 299.74,
    cy: 672.25,
    r: 11.92,
    fill: "#fff"
  }), React.createElement("path", {
    fill: "#fff",
    d: "M167.37 337.21h83.48v62.92h-83.48z"
  }), React.createElement("path", {
    fill: primaryColor,
    opacity: 0.2,
    d: "M175.54 342.66h27.83v15.73h-27.83z"
  }), React.createElement("path", {
    fill: "#e6e8ec",
    d: "M210.02 342.66h32.67v3.63h-32.67zM210.02 348.71h22.99v3.63h-22.99zM210.02 354.76h32.67v3.63h-32.67zM175.54 360.81h67.15v3.63h-67.15zM175.54 366.86h67.15v3.63h-67.15zM175.54 372.91h67.15v3.63h-67.15zM175.54 378.96h61.71v3.63h-61.71zM175.54 385.01h67.15v3.63h-67.15zM175.54 391.06h67.15v3.63h-67.15z"
  }), React.createElement("path", {
    fill: "#fff",
    d: "M259.33 337.21h83.48v62.92h-83.48z"
  }), React.createElement("path", {
    fill: primaryColor,
    opacity: 0.2,
    d: "M267.49 342.66h27.83v15.73h-27.83z"
  }), React.createElement("path", {
    fill: "#e6e8ec",
    d: "M301.98 342.66h32.67v3.63h-32.67zM301.98 348.71h22.99v3.63h-22.99zM301.98 354.76h32.67v3.63h-32.67zM267.49 360.81h67.15v3.63h-67.15zM267.49 366.86h67.15v3.63h-67.15zM267.49 372.91h67.15v3.63h-67.15zM267.49 378.96h61.71v3.63h-61.71zM267.49 385.01h67.15v3.63h-67.15zM267.49 391.06h67.15v3.63h-67.15z"
  }), React.createElement("path", {
    fill: "#fff",
    d: "M351.28 337.21h83.48v62.92h-83.48z"
  }), React.createElement("path", {
    fill: primaryColor,
    opacity: 0.2,
    d: "M359.45 342.66h27.83v15.73h-27.83z"
  }), React.createElement("path", {
    fill: "#e6e8ec",
    d: "M393.93 342.66h32.67v3.63h-32.67zM393.93 348.71h22.99v3.63h-22.99zM393.93 354.76h32.67v3.63h-32.67zM359.45 360.81h67.15v3.63h-67.15zM359.45 366.86h67.15v3.63h-67.15zM359.45 372.91h67.15v3.63h-67.15zM359.45 378.96h61.71v3.63h-61.71zM359.45 385.01h67.15v3.63h-67.15zM359.45 391.06h67.15v3.63h-67.15z"
  }), React.createElement("path", {
    fill: "#fff",
    d: "M167.37 407.99h83.48v62.92h-83.48z"
  }), React.createElement("path", {
    fill: primaryColor,
    opacity: 0.2,
    d: "M175.54 413.44h27.83v15.73h-27.83z"
  }), React.createElement("path", {
    fill: "#e6e8ec",
    d: "M210.02 413.44h32.67v3.63h-32.67zM210.02 419.49h22.99v3.63h-22.99zM210.02 425.54h32.67v3.63h-32.67zM175.54 431.59h67.15v3.63h-67.15zM175.54 437.64h67.15v3.63h-67.15zM175.54 443.69h67.15v3.63h-67.15zM175.54 449.74h61.71v3.63h-61.71zM175.54 455.79h67.15v3.63h-67.15zM175.54 461.84h67.15v3.63h-67.15z"
  }), React.createElement("path", {
    fill: "#fff",
    d: "M259.33 407.99h83.48v62.92h-83.48z"
  }), React.createElement("path", {
    fill: primaryColor,
    opacity: 0.2,
    d: "M267.49 413.44h27.83v15.73h-27.83z"
  }), React.createElement("path", {
    fill: "#e6e8ec",
    d: "M301.98 413.44h32.67v3.63h-32.67zM301.98 419.49h22.99v3.63h-22.99zM301.98 425.54h32.67v3.63h-32.67zM267.49 431.59h67.15v3.63h-67.15zM267.49 437.64h67.15v3.63h-67.15zM267.49 443.69h67.15v3.63h-67.15zM267.49 449.74h61.71v3.63h-61.71zM267.49 455.79h67.15v3.63h-67.15zM267.49 461.84h67.15v3.63h-67.15z"
  }), React.createElement("path", {
    fill: "#fff",
    d: "M351.28 407.99h83.48v62.92h-83.48z"
  }), React.createElement("path", {
    fill: primaryColor,
    opacity: 0.2,
    d: "M359.45 413.44h27.83v15.73h-27.83z"
  }), React.createElement("path", {
    fill: "#e6e8ec",
    d: "M393.93 413.44h32.67v3.63h-32.67zM393.93 419.49h22.99v3.63h-22.99zM393.93 425.54h32.67v3.63h-32.67zM359.45 431.59h67.15v3.63h-67.15zM359.45 437.64h67.15v3.63h-67.15zM359.45 443.69h67.15v3.63h-67.15zM359.45 449.74h61.71v3.63h-61.71zM359.45 455.79h67.15v3.63h-67.15zM359.45 461.84h67.15v3.63h-67.15z"
  }), React.createElement("path", {
    fill: "#fff",
    d: "M167.37 481.57h83.48v62.92h-83.48z"
  }), React.createElement("path", {
    fill: primaryColor,
    opacity: 0.2,
    d: "M175.54 487.02h27.83v15.73h-27.83z"
  }), React.createElement("path", {
    fill: "#e6e8ec",
    d: "M210.02 487.02h32.67v3.63h-32.67zM210.02 493.07h22.99v3.63h-22.99zM210.02 499.12h32.67v3.63h-32.67zM175.54 505.17h67.15v3.63h-67.15zM175.54 511.22h67.15v3.63h-67.15zM175.54 517.27h67.15v3.63h-67.15zM175.54 523.32h61.71v3.63h-61.71zM175.54 529.37h67.15V533h-67.15zM175.54 535.42h67.15v3.63h-67.15z"
  }), React.createElement("path", {
    fill: "#fff",
    d: "M259.33 481.57h83.48v62.92h-83.48z"
  }), React.createElement("path", {
    fill: primaryColor,
    opacity: 0.2,
    d: "M267.49 487.02h27.83v15.73h-27.83z"
  }), React.createElement("path", {
    fill: "#e6e8ec",
    d: "M301.98 487.02h32.67v3.63h-32.67zM301.98 493.07h22.99v3.63h-22.99zM301.98 499.12h32.67v3.63h-32.67zM267.49 505.17h67.15v3.63h-67.15zM267.49 511.22h67.15v3.63h-67.15zM267.49 517.27h67.15v3.63h-67.15zM267.49 523.32h61.71v3.63h-61.71zM267.49 529.37h67.15V533h-67.15zM267.49 535.42h67.15v3.63h-67.15z"
  }), React.createElement("path", {
    fill: "#fff",
    d: "M351.28 481.57h83.48v62.92h-83.48z"
  }), React.createElement("path", {
    fill: primaryColor,
    opacity: 0.2,
    d: "M359.45 487.02h27.83v15.73h-27.83z"
  }), React.createElement("path", {
    fill: "#e6e8ec",
    d: "M393.93 487.02h32.67v3.63h-32.67zM393.93 493.07h22.99v3.63h-22.99zM393.93 499.12h32.67v3.63h-32.67zM359.45 505.17h67.15v3.63h-67.15zM359.45 511.22h67.15v3.63h-67.15zM359.45 517.27h67.15v3.63h-67.15zM359.45 523.32h61.71v3.63h-61.71zM359.45 529.37h67.15V533h-67.15zM359.45 535.42h67.15v3.63h-67.15z"
  }), React.createElement("path", {
    fill: "#fff",
    d: "M167.37 552.35h83.48v62.92h-83.48z"
  }), React.createElement("path", {
    fill: primaryColor,
    opacity: 0.2,
    d: "M175.54 557.8h27.83v15.73h-27.83z"
  }), React.createElement("path", {
    fill: "#e6e8ec",
    d: "M210.02 557.8h32.67v3.63h-32.67zM210.02 563.85h22.99v3.63h-22.99zM210.02 569.9h32.67v3.63h-32.67zM175.54 575.95h67.15v3.63h-67.15zM175.54 582h67.15v3.63h-67.15zM175.54 588.05h67.15v3.63h-67.15zM175.54 594.1h61.71v3.63h-61.71zM175.54 600.15h67.15v3.63h-67.15zM175.54 606.2h67.15v3.63h-67.15z"
  }), React.createElement("path", {
    fill: "#fff",
    d: "M259.33 552.35h83.48v62.92h-83.48z"
  }), React.createElement("path", {
    fill: primaryColor,
    opacity: 0.2,
    d: "M267.49 557.8h27.83v15.73h-27.83z"
  }), React.createElement("path", {
    fill: "#e6e8ec",
    d: "M301.98 557.8h32.67v3.63h-32.67zM301.98 563.85h22.99v3.63h-22.99zM301.98 569.9h32.67v3.63h-32.67zM267.49 575.95h67.15v3.63h-67.15zM267.49 582h67.15v3.63h-67.15zM267.49 588.05h67.15v3.63h-67.15zM267.49 594.1h61.71v3.63h-61.71zM267.49 600.15h67.15v3.63h-67.15zM267.49 606.2h67.15v3.63h-67.15z"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M351.28 552.35h83.48v62.92h-83.48z"
  }), React.createElement("path", {
    d: "M283.71 442.62h-144.8a14.32 14.32 0 0 0-14.35 14.29V774a14.32 14.32 0 0 0 14.35 14.29h144.8A14.32 14.32 0 0 0 298.06 774V456.92a14.32 14.32 0 0 0-14.35-14.3z",
    transform: "translate(-56.59 -55.12)",
    fill: "url(#prefix__c)"
  }), React.createElement("rect", {
    x: 69.3,
    y: 390.16,
    width: 170.85,
    height: 341.7,
    rx: 11,
    ry: 11,
    fill: "#535461"
  }), React.createElement("path", {
    fill: "#f1f1f4",
    d: "M81.88 421.94h145.68v278.12H81.88z"
  }), React.createElement("circle", {
    cx: 137.5,
    cy: 406.05,
    r: 1.32,
    fill: "#fff"
  }), React.createElement("rect", {
    x: 144.13,
    y: 404.72,
    width: 29.14,
    height: 2.65,
    rx: 1,
    ry: 1,
    fill: "#fff"
  }), React.createElement("circle", {
    cx: 154.06,
    cy: 713.31,
    r: 9.27,
    fill: "#fff"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M105.05 438.59h99.34v74.87h-99.34z"
  }), React.createElement("path", {
    fill: "#fff",
    d: "M105.05 522.82h99.34v74.87h-99.34z"
  }), React.createElement("path", {
    fill: primaryColor,
    opacity: 0.2,
    d: "M114.77 529.3h33.11v18.72h-33.11z"
  }), React.createElement("path", {
    fill: "#e6e8ec",
    d: "M155.8 529.3h38.87v4.32H155.8zM155.8 536.5h27.36v4.32H155.8zM155.8 543.69h38.87v4.32H155.8zM114.77 550.89h79.91v4.32h-79.91zM114.77 558.09h79.91v4.32h-79.91zM114.77 565.29h79.91v4.32h-79.91zM114.77 572.49h73.43v4.32h-73.43zM114.77 579.69h79.91v4.32h-79.91zM114.77 586.89h79.91v4.32h-79.91z"
  }), React.createElement("path", {
    fill: "#fff",
    d: "M105.05 607.22h99.34v74.87h-99.34z"
  }), React.createElement("path", {
    fill: primaryColor,
    opacity: 0.2,
    d: "M114.77 613.7h33.11v18.72h-33.11z"
  }), React.createElement("path", {
    fill: "#e6e8ec",
    d: "M155.8 613.7h38.87v4.32H155.8zM155.8 620.9h27.36v4.32H155.8zM155.8 628.1h38.87v4.32H155.8zM114.77 635.3h79.91v4.32h-79.91zM114.77 642.5h79.91v4.32h-79.91zM114.77 649.7h79.91v4.32h-79.91zM114.77 656.9h73.43v4.32h-73.43zM114.77 664.09h79.91v4.32h-79.91zM114.77 671.29h79.91v4.32h-79.91z"
  }), React.createElement("path", {
    d: "M600.25 697.71c-6.72-8.15-14.86-17.52-13.72-28.37.92-8.79-1.29-16.91-.85-25.72.62-12.52-1.91-22.33-10.93-30.36-5.27-4.69-14.08-8.38-16.7-7.44-5.2 1.86-10.87 1.15-16.22 2.4-4.06 1-6.77 2.41-8.44 4.24-3.37 3-3.43 7.26-1.89 11.81a19.94 19.94 0 0 0 9.88 28c-3.75 1.56-7 5.17-8.25 12.49a85.41 85.41 0 0 1-4 14.76 24 24 0 0 1-2.44 1c.18.07.37.12.56.19-.39.15-.79.3-1.18.44a12.88 12.88 0 0 0 2.22.64 84.83 84.83 0 0 1-10.9 19.87s-11.32 2.5-15.72-1.87c0 0 .72.84 1.69 2.1-4.31-1.79-11.37-4.7-17.41-7.1-4.38-1.74-5.51 0-5.45 2.42a8.09 8.09 0 0 0-3.06 1 29.55 29.55 0 0 0-4.06-2.18c-2.52-.62-10.69-5-18.87 10-4.76 8.73-17 24.65-26.35 36.44-18.25 8.39-42 19-50.82 21.69h-5.64c-.74-1.21-1.26-2-1.26-2l-.44.29-.19-.29s-11.11 7.69-22.39 7.75a21.22 21.22 0 0 1-4.76-.62c-5.19-1.31-8.84-1.89-11.45-1.84-3.09-.05-4.84.68-5.93 2.06a5.43 5.43 0 0 0-.39.57 6.71 6.71 0 0 0-.33.63c-.1.22-.19.45-.28.69a1.41 1.41 0 0 0 .35 1.18 6.32 6.32 0 0 0 .49.62l.31.34a50 50 0 0 0 7.23 5.59c.93.63 1.91 1.27 2.94 1.93l1.95 1.24 1.74 1.09.7.43.78.48 1.39.85.83.5 1.56.93 1.26.75c3.3 2 6.6 3.84 9.56 5.51l2.08 1.17.2.11 1.33.74 2.31 1.28 1.59.87.74.41.8.43.16.09 1.38.75a2 2 0 0 0 1.61-.44c.4-1.7 1.38-5.34 2.42-5.62s5.58-8.24 6.87-13.54h12.27a54.11 54.11 0 0 0 7.17-1.09c-3.17 2.26-6.31 3.68-8.75 3.07-5.16-1.28-10.05 1.86-10.54 5l-.06.19v1.44c0 .06 0 .17.06.25s0 .11 0 .16a3 3 0 0 0 .13.32v.08a3.27 3.27 0 0 0 .23.38l.1.13.2.25.14.14.23.22.17.14.27.2.2.13.33.19.22.12.41.19.21.09c.22.09.45.18.7.26s.86.26 1.39.39l.53.13.77.18.41.09 1.68.34.82.15.67.12 1.54.27 3 .49 2.65.4 3.45.49.76.1 1.24.17 1.78.24 1.22.16 3.15.4 1 .12 2 .24c2.61.31 5.14.61 7.46.87l2.69.3 1.36.15.58.06 1.63.18.91.1 1.11.12 1.57.16h.17l1 .1a.91.91 0 0 0 1-.89v-.1a.89.89 0 0 0 .15-.48 20.65 20.65 0 0 1 .56-4.44c.07-.25.15-.51.23-.76l.1-.29c.11-.31.22-.62.35-.94a6.75 6.75 0 0 0 .23-.69l.06-.22c0-.12.06-.25.09-.38 1.27-4.32-.26-12.37-.7-15.53a16.86 16.86 0 0 0-.69-3 1.22 1.22 0 0 0 .24 0 7.16 7.16 0 0 0 1.82-1c9.27-3.31 17.1-7.09 19.57-10.88a16.94 16.94 0 0 1 12 1.25c4.8 2.39 41.13 14.24 58.05 19.72 3 2.62 5.42 4.15 6.73 4 0 0 21.53 3.48 30.19-3.32.77.53 1.25.82 1.25.82s12.58-6.25 14.47-14.37c.61-2.63 1.16-6.52 1.72-10.82a15.73 15.73 0 0 0 4.57-11.06c.39-13.65 5.68-29.24 9.6-43.13 4.76.37 6.6-.52 11-2.68l-.19-.25zm-72.12 20.44l-2.4-.81a20 20 0 0 0 2.09-3.48zm-13.54 5.74l14.58 8.75.13 1.78a12.77 12.77 0 0 0 .12 4.07c-6.42-5.71-13.94-12.64-14.82-14.6zm-5.95-12.74c-1.59-.66-2.91-1.25-3.81-1.74l3.38.21a7.55 7.55 0 0 1 .44 1.53zm-39 14.25s2.52-5.62 8.18 3.75c.88 1.46 2.5 3.77 4.64 6.65L466 733.59a24 24 0 0 0 3.62-8.19z",
    transform: "translate(-56.59 -55.12)",
    fill: "url(#prefix__d)"
  }), React.createElement("path", {
    d: "M449.26 647.69s-11.54-4.86-20.64-8.5-3.64 8.5-3.64 8.5 15.18 4.25 15.18 4.86 12.75 1.21 12.75 1.21z",
    fill: "#f7c4a7"
  }), React.createElement("path", {
    d: "M449.26 647.69s-11.54-4.86-20.64-8.5-3.64 8.5-3.64 8.5 15.18 4.25 15.18 4.86 12.75 1.21 12.75 1.21z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M498.41 599.73s-20.64-10.93-24.29 10.32a86.75 86.75 0 0 1-15.15 35.83s-10.93 2.43-15.18-1.82c0 0 10.32 12.14 5.46 13.36 0 0 10.93 7.89 15.79 5.46s8.5-18.82 10.32-23.07 8.5-41.3 23.05-40.08z",
    fill: "#575988"
  }), React.createElement("path", {
    d: "M498.41 599.73s-20.64-10.93-24.29 10.32a86.75 86.75 0 0 1-15.15 35.83s-10.93 2.43-15.18-1.82c0 0 10.32 12.14 5.46 13.36 0 0 10.93 7.89 15.79 5.46s8.5-18.82 10.32-23.07 8.5-41.3 23.05-40.08z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M486.9 592.44s12.75 14.57 13.36 26.71 14.57-12.75 15.79-13.36-12.15-21.24-13.37-27.91-15.78 14.56-15.78 14.56z",
    fill: "#f7c4a7"
  }), React.createElement("path", {
    fill: "#f7c4a7",
    d: "M495.7 598.67l-8.04 7.28 3.79 15.33 10.32-9.71-1.21-9.71-4.86-3.19zM327.83 706.59h-13.96l5.46 13.35 13.36-3.64-4.86-9.71z"
  }), React.createElement("path", {
    d: "M317.09 704.66s-14.44 10.07-26.81 6.93-15.71-2-17.15 2.09c-1.33 3.72 34.51 23.41 40.22 26.52a.65.65 0 0 0 1-.43c.39-1.65 1.33-5.19 2.33-5.46 1.31-.35 7.3-11.52 7-15.93s-6.59-13.72-6.59-13.72z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M316.49 704.66s-14.44 10.07-26.81 6.93-15.71-2-17.15 2.09c-1.33 3.72 34.51 23.41 40.22 26.52a.65.65 0 0 0 1-.43c.39-1.65 1.33-5.19 2.33-5.46 1.31-.35 7.3-11.52 7-15.93s-6.59-13.72-6.59-13.72z",
    fill: "#f3b5b7"
  }), React.createElement("path", {
    d: "M435.9 680.48l-40.68-5.46s-66.18 31.57-74.07 32.18l1.82 14h12.14c4.86 0 52.21-10.32 58.89-20.64a16.26 16.26 0 0 1 11.54 1.21c6.07 3 64.36 21.86 64.36 21.86z",
    fill: "#575988"
  }), React.createElement("path", {
    d: "M435.9 680.48l-40.68-5.46s-66.18 31.57-74.07 32.18l1.82 14h12.14c4.86 0 52.21-10.32 58.89-20.64a16.26 16.26 0 0 1 11.54 1.21c6.07 3 64.36 21.86 64.36 21.86z",
    opacity: 0.1
  }), React.createElement("path", {
    fill: "#f7c4a7",
    d: "M363.65 699.3l-6.68 8.5 6.68 3.64 9.72-7.28-9.72-4.86z"
  }), React.createElement("path", {
    d: "M479.61 689.58s-21.84-18.7-23.37-22.1-37.34-26.46-39.77-27.07-10.32-4.86-18.21 9.71-37 49.78-37 49.78 9.11 12.75 12.14 12.14 37-29.14 39.46-43.11c0 0 2.43-5.46 7.89 3.64s40.68 52.82 47.36 52.21c0 0 26.11 4.25 31.57-6.07s-20.07-29.13-20.07-29.13z",
    fill: "#575988"
  }), React.createElement("path", {
    fill: "url(#prefix__e)",
    d: "M382.57 591.56h90.91v68.51h-90.91z"
  }), React.createElement("path", {
    fill: "#fff",
    d: "M386.28 594.35h83.48v62.92h-83.48z"
  }), React.createElement("path", {
    fill: primaryColor,
    opacity: 0.2,
    d: "M394.45 599.8h27.83v15.73h-27.83z"
  }), React.createElement("path", {
    fill: "#e6e8ec",
    d: "M428.93 599.8h32.67v3.63h-32.67zM428.93 605.85h22.99v3.63h-22.99zM428.93 611.9h32.67v3.63h-32.67zM394.45 617.95h67.15v3.63h-67.15zM394.45 624h67.15v3.63h-67.15zM394.45 630.05h67.15v3.63h-67.15zM394.45 636.1h61.71v3.63h-61.71zM394.45 642.15h67.15v3.63h-67.15zM394.45 648.2h67.15v3.63h-67.15z"
  }), React.createElement("path", {
    d: "M492.06 600.64s-7.59 3.34-8.2 17.3-14 37.64-14 37.64l1.21 27.93s14.57 14.57 15.79 23.68 11.55 15.18 11.55 15.18 12.14-6.07 14-14 3-27.32 6.07-34.61 1.21-52.82 1.21-52.82l-9.11-15.79-4.86-5.46-12.75 14.57s-6.98-9.38-.91-13.62z",
    fill: "#f3b5b7"
  }), React.createElement("path", {
    d: "M474.15 674.4s-1.82-21.86 3.64-26.71l10.93-31s3.95-14.87 3.34-16.09-14.27 11.84-14.27 11.84l-9.11 32.18 2.43 34z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M473.54 674.4s-1.82-21.86 3.64-26.71l10.93-31s4.25-15.18 3.64-16.39-14.57 12.14-14.57 12.14l-9.11 32.18 2.43 34z",
    fill: "#575988"
  }), React.createElement("path", {
    d: "M477.79 664.69s-30.38-9.71-32.18-12.14-21.25-18.21-27.93-7.29 24.89 14 24.89 14l32.18 19.43z",
    fill: "#f7c4a7"
  }), React.createElement("path", {
    d: "M364.96 707.74l-9-1.62s-14.72 18.85-22.38 16.94-14.72 6.34-6.62 9c7.32 2.39 38.91 5.74 44.95 6.36a.88.88 0 0 0 1-.86 19.33 19.33 0 0 1 1.34-6.84c1.62-4 0-12.52-.45-15.76a15.68 15.68 0 0 0-1.77-5.45z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M364.82 708.33l-9-1.62s-14.7 18.86-22.41 16.94-14.72 6.34-6.62 9c7.32 2.39 38.91 5.74 44.95 6.36a.88.88 0 0 0 1-.86 19.33 19.33 0 0 1 1.34-6.84c1.62-4 0-12.52-.45-15.76a15.68 15.68 0 0 0-1.77-5.45z",
    fill: "#f3b5b7"
  }), React.createElement("circle", {
    cx: 491.45,
    cy: 580,
    r: 19.43,
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 489.63,
    cy: 580,
    r: 19.43,
    fill: "#f7c4a7"
  }), React.createElement("path", {
    d: "M508.75 599.12s23.07 7.89 23.07 24.29-12.75 42.5-13.36 63.75-34 18.21-34 18.21-4.86-71.64 0-77.11 26.72-26.71 24.29-29.14z",
    fill: "#575988"
  }), React.createElement("path", {
    d: "M504.5 633.12s-8.5 37.64-28.54 31c0 0-10.32 15.18-3 21.86 0 0 17.61 4.25 29.14-7.29s20.01-15.81 21.83-29.81 3-33.39-3-31.57-16.43 15.81-16.43 15.81z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M505.11 632.51s-8.5 37.64-28.54 31c0 0-10.32 15.18-3 21.86 0 0 17.61 4.25 29.14-7.29s20-15.79 21.86-29.75 3-33.39-3-31.57-16.46 15.75-16.46 15.75z",
    fill: "#575988"
  }), React.createElement("path", {
    d: "M374.6 729.36c0 .06 0 .12-.06.17a17.78 17.78 0 0 0-1 3.21c.14-.48.31-1 .51-1.45a8.81 8.81 0 0 0 .55-1.93zM327.28 730.88c-2.5-.82-3.55-2.17-3.59-3.59-1 2-.38 4.2 3.15 5.36 7.32 2.39 38.92 5.74 44.95 6.36a.88.88 0 0 0 1-.87.89.89 0 0 0-.79-.9c-6.65-.72-37.5-4.01-44.72-6.36zM273.36 712.61a7.48 7.48 0 0 1 .59-1.29 5.92 5.92 0 0 0-1.43 2.36c-1.33 3.72 34.51 23.4 40.22 26.52a.66.66 0 0 0 1-.43.66.66 0 0 0-.32-.73c-6.34-3.46-41.38-22.75-40.06-26.43zM316.87 733.24c-.32.09-.64.51-.93 1.11h.1c.26-.07.72-.59 1.28-1.4a1.18 1.18 0 0 1-.45.29z",
    fill: "#dddbe2"
  }), React.createElement("path", {
    d: "M486.93 597.1c-1.71 3.77-2.07 8-3.33 12a26.37 26.37 0 0 1-16.25 16.86c6.31 2.52 13.75-.56 18.63-5.66s7.73-11.89 10.47-18.49c7.08 4.76 6.22 15.7 8.59 24.22a26.86 26.86 0 0 0 14.3 17.09 25.6 25.6 0 0 0 21.9-.44c-6.49-7.92-15.73-18.78-14.63-29.32.89-8.54-5.24-15.06-4.81-23.62.6-12.16-4-18.31-12.75-26.11-5.09-4.56 2.92-11-3.64-9.11-2.58.74-5.3-2-7.83-1.11-5 1.8-10.49 1.12-15.65 2.33-26.83 6.28 7.48 35.85 5 41.36z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M487.54 596.49c-1.71 3.77-2.07 8-3.33 12a26.37 26.37 0 0 1-16.25 16.86c6.31 2.52 13.75-.56 18.63-5.66s7.73-11.89 10.47-18.49c7.08 4.76 6.22 15.7 8.59 24.22a26.86 26.86 0 0 0 14.3 17.09 25.6 25.6 0 0 0 21.9-.44c-6.49-7.92-15.12-17-14-27.5.89-8.54-.44-17.31 0-25.87.6-12.16-5.35-23.87-14.06-31.67-5.09-4.56-13-5.14-15.57-4.23-5 1.8-10.49 1.12-15.65 2.33-26.86 6.29 7.47 35.85 4.97 41.36z",
    fill: "#b96b6b"
  }), React.createElement("path", {
    d: "M220.42 836.49c35-10.77 55.66-9.88 55.66-9.88l-2.87-16.27a12.3 12.3 0 0 0 2.42-2.13s-3.59-19.75 0-24.69 13.47-49.82 13.47-49.82v-15.27c18-6.28 39.05-42.64 39.05-42.64L354.64 744s26.48 52.52 30.07 54.31c2.87 1.43 4.3 13.18 4.77 17.85l-.22.07c.11 1.13.16 1.83.16 1.83l.21-.14v.14a10.29 10.29 0 0 1 1.4-.82c-5.17 5.94-12.91 14.48-19.35 20.12-3.55 3.11 2.82 5.51 5.8 5.46a14.62 14.62 0 0 1 5 .71c15.09 5.21 39.9-13.81 39.9-13.81l-6.21-17.32c1.62-.13 2.62-.19 2.62-.19s-20.2-70.92-29.63-77.66a43 43 0 0 1-8-7.58 28 28 0 0 1-6.33-19.44l3.31-58.19c5.32-.78 8.75-1.43 8.75-1.43s1.24-15.9 1.2-28.1c0-6.35-.26-11.92-1.2-14.1-1.11-2.58-1.46-7.74-1.48-12.92 0-7 .58-13.56.58-13.56s7.18-9.43 17.06-31c4.35-9.49 5.48-17 5.38-22.38a30.53 30.53 0 0 0-.72-7.46 9.35 9.35 0 0 0-4.23-5.87c-5.68-3.48-18.61-12.07-22.42-20.39-4.84-10.56-11.83-12.06-12.11-12.12l-.43-1.86a17.45 17.45 0 0 0 5.62-8.52c1.46-4.5 1.76-9.3 3-13.87.6-2.2 1.43-4.33 2-6.53a25.79 25.79 0 0 0 .81-6.78 21 21 0 0 0-2-9.65c-2.32-4.77-6.94-8.52-12.2-9.14-2.9-.34-6.11.16-8.49-1.53-1.64-1.17-2.5-3.16-4-4.55-2.85-2.7-7.41-2.56-11.12-1.3a23.69 23.69 0 0 0-12.16 9.47c-1.73 2.66-2.94 5.71-5.16 8-1.87 1.91-4.32 3.13-6.38 4.83a13 13 0 0 0-5 10v.9c.1 3.86 2.79 7.7 6.57 8.48a9.7 9.7 0 0 0 3 .08A24.24 24.24 0 0 0 341 488c-.06.32-.13.64-.2 1h.21a34.65 34.65 0 0 1-1.62 4.56h-.29l.73-1.3-10.3-.71a17.26 17.26 0 0 0-8.72 1.63c-3.55 1.72-7.43 5-7.91 11.2C312 516 290 533.5 290 533.5c-7.63 12.12-57.46 14.36-57.46 14.36s.22.28.32.43l-1-.19-3.77-.69s-11.67-34.56-22.89-28.28 19.3 40.4 19.3 40.4l8.82.59.89.06a53.85 53.85 0 0 1-1.39 6.63c-.12.44-.21.72-.23.79s23.2-2.68 42.91-2.25h1.78l1.26-.06c1 10.83 16.44 32.84 16.44 32.84l9.53 2 .72.15a79.68 79.68 0 0 1-11.6 17.59l-3.14 17.51.25-.06-.25 1.41a3.39 3.39 0 0 0 1.45-.76c-6.15 16.32-16.35 41.72-23.44 50.58-10.77 13.47-9.43 35-9.43 35s-10.77 56.56-10.32 66.88a26.6 26.6 0 0 1-3.89 14.13 46.72 46.72 0 0 0-5.54 7.87c-8.08 13.92-21.1 13-21.1 13-11.22 7.22 2.2 13.06 2.2 13.06zm69.33-273.79l1.16-.46.27-.11 1.11-.48.19-.09 1-.46.22-.1 1.06-.53.25-.13 1-.53h.08l1-.58.24-.14 1-.58.16-.1.87-.53.2-.12.93-.59.21-.14.86-.57.08-.05.88-.61.2-.14.84-.6.13-.09.74-.54.16-.12.77-.59.16-.12.7-.55h.06l.71-.57.15-.12.67-.55.06-.05.6-.51.1-.09.59-.51.09-.08.54-.49.52-.47.07-.07 1-1 1.46-.12c1.24 1.61 1.73 4.46 1.78 7.73-.14 8.39-2.68 18.75-2.68 18.75a58.47 58.47 0 0 1-2.66 15.14 8.92 8.92 0 0 1-3.17-.77s-.06.32-.15.86l-.86-.22-4.37-1.09s-3.63-18.48-10.98-26.12z",
    transform: "translate(-56.59 -55.12)",
    fill: "url(#prefix__f)"
  }), React.createElement("path", {
    d: "M354.89 746.67l8.33 23.21s-22.81 17.5-37.63 13.88a41.42 41.42 0 0 0-6.8-1.1c-3.07-.23-8.35-2.46-5.09-5.31 10.52-9.2 24.54-26.29 24.54-26.29zM216.41 744.48l3.94 22.35s-20.16-.88-54.34 9.64c0 0-13.15-5.7-2.19-12.71 0 0 12.71.88 20.6-12.71s12.71-11.83 12.71-11.83z",
    fill: "#4f4d59"
  }), React.createElement("path", {
    d: "M320.71 582.33l-3.86 68a28.13 28.13 0 0 0 6.71 19.89 41.23 41.23 0 0 0 7.24 6.75c9.2 6.57 28.92 75.81 28.92 75.81s-22.35 1.31-28.48 5.7c0 0-1.31-17.53-4.82-19.28s-29.36-53-29.36-53l-25.87-66.62s-20.6 35.5-38.13 41.63v14.9s-9.64 43.82-13.15 48.64 0 24.1 0 24.1-10.08 12.71-33.3-.88c0 0 7.45-8.33 7-18.41s10.1-65.28 10.1-65.28-1.31-21 9.2-34.18 28-63.54 28-63.54l12.06-25.95z",
    fill: "#787c9c"
  }), React.createElement("g", {
    opacity: 0.1
  }, React.createElement("path", {
    d: "M355.55 752.8s-19.72-69.24-28.92-75.81a41.75 41.75 0 0 1-7.61-7.19 27.81 27.81 0 0 1-6.33-19.44l3.86-68-64.63-39.84.88-1.89 67.69 41.72-3.86 68a27.81 27.81 0 0 0 6.33 19.44 41.75 41.75 0 0 0 7.61 7.19c9.2 6.57 28.92 75.81 28.92 75.81s-22.35 1.31-28.48 5.7c0 0-.05-.68-.16-1.79 8.62-2.95 24.7-3.9 24.7-3.9zM215.76 748.88s-3.51-19.28 0-24.1 13.15-48.64 13.15-48.64v-14.9c17.53-6.14 38.13-41.63 38.13-41.63l1.53 3.95c-5.94 9.42-21.79 32.81-35.71 37.68v14.9s-9.64 43.82-13.15 48.64 0 24.1 0 24.1-4.89 6.15-15.69 5.32c8.05-.69 11.74-5.32 11.74-5.32z"
  })), React.createElement("path", {
    d: "M169.96 506.08l8.61.57 4.54.3v-11l-6-1.08-3.69-.67s-11.39-33.74-22.35-27.61 18.89 39.49 18.89 39.49zM308 415.81s5.7 21.91 7.45 35.5-40.75 2.63-40.75 2.63 16.21-19.72 7-30.24z",
    fill: "#714b4f"
  }), React.createElement("path", {
    d: "M261.99 506.96l-.88 8.33 13.58-.88 13.58-11.83 13.58-38.13 8.78-13.57 6.57-8.33-2.63-10.08s-1.2 1-3.23 2.6c-6.67 5.11-22.33 15.72-33.77 12.79a13.64 13.64 0 0 1-1.56-.49l-17.09 29.36z",
    fill: "#e6e6f0"
  }), React.createElement("path", {
    d: "M311.07 429.88s7 1.31 11.83 11.83c3.71 8.09 16.22 16.43 21.81 19.86a9.35 9.35 0 0 1 4.24 5.91c1.13 5 1.56 14.3-4.58 27.7-9.64 21-16.65 30.24-16.65 30.24s-1.75 21 .88 27.17 0 39.88 0 39.88-46 8.76-61.35 0-13.15-42.59-13.15-42.59-14.46 30.7-19.69 31.58l3-17.09s17.09-18.41 18-42.07c0 0 5.26-21.47.88-27.17 0 0-74.06 6.14-78.44.88 0 0 48.64-2.19 56.09-14 0 0 21.47-17.09 22.35-28.48a12.6 12.6 0 0 1 6.57-10.32 17.16 17.16 0 0 1 9.82-2.19l9.9.68s-17.08 30.18-16.17 34.18-.88 35.93-.88 35.93 19.72-42.51 28.48-47.33 18.81-24.6 18.81-24.6l-1.75-10",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M261.99 506.96l-.88 8.33 13.58-.88 13.58-11.83 13.58-38.13 8.78-13.57 6.57-8.33-2.63-10.08s-1.2 1-3.23 2.6l.6 3.46s-10.08 19.79-18.84 24.61-28.48 47.33-28.48 47.33 1.75-32 .88-35.93c-.6-2.68 7.08-17.45 12.07-26.68a13.64 13.64 0 0 1-1.56-.49l-17.09 29.36zM178.57 506.66l4.54.3v-11l-6-1.08c2.11 2.8 2.04 7.66 1.46 11.78z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M311.07 428.52s7 1.31 11.83 11.83c3.71 8.09 16.22 16.43 21.81 19.86a9.35 9.35 0 0 1 4.24 5.91c1.13 5 1.56 14.3-4.58 27.7-9.64 21-16.65 30.24-16.65 30.24s-1.75 21 .88 27.17 0 39.88 0 39.88-46 8.76-61.35 0-13.15-42.51-13.15-42.51-14.46 30.67-19.69 31.54l3-17.09s17.09-18.41 18-42.07c0 0 5.26-21.47.88-27.17 0 0-17.09 18.41-36.37 18S177.85 514 177.85 514s4.38-14 0-19.28c0 0 48.64-2.19 56.09-14 0 0 21.47-17.09 22.35-28.48a12.6 12.6 0 0 1 6.58-10.36 17.16 17.16 0 0 1 9.82-2.19l9.9.68s-17.09 30.22-16.18 34.16-.88 35.93-.88 35.93 19.72-42.51 28.48-47.33 18.84-24.61 18.84-24.61l-1.75-10",
    fill: "#67647e"
  }), React.createElement("path", {
    d: "M320.71 474.53s-10.52 35.5-16.65 39.88-43.38 26.73-54.34 21.47c0 0-2.63 13.15 1.31 16.21 0 0 40.86-1.6 41.19-1.75 0 0 26.73-3.51 31.11-16.65s9.64-35.5 9.64-35.5z",
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 264.62,
    cy: 512.44,
    rx: 1.53,
    ry: 2.19,
    fill: "#ba7855"
  }), React.createElement("ellipse", {
    cx: 260.24,
    cy: 527.78,
    rx: 1.53,
    ry: 2.19,
    fill: "#ba7855"
  }), React.createElement("g", {
    opacity: 0.1
  }, React.createElement("path", {
    d: "M325.53 590.66s2.63-33.74 0-39.88-.88-27.17-.88-27.17 7-9.2 16.65-30.24c6.14-13.4 5.7-22.7 4.58-27.7a9.35 9.35 0 0 0-4.25-5.91c-5.59-3.43-18.1-11.77-21.8-19.86-2.72-5.93-6.13-8.94-8.6-10.43l-.17-1s7 1.31 11.83 11.83c3.71 8.09 16.22 16.43 21.8 19.86a9.35 9.35 0 0 1 4.25 5.91c1.13 5 1.56 14.3-4.58 27.7-9.64 21-16.65 30.24-16.65 30.24s-1.75 21 .88 27.17 0 39.88 0 39.88-32.87 6.26-52.31 2.91c19.64 2.33 49.25-3.31 49.25-3.31zM266.41 474.53c.6 2.7 0 18.58-.49 28.3-2.12 4.33-3.45 7.19-3.45 7.19s1.75-32 .88-35.93c-.83-3.75 14.56-31.25 16.09-34l3.19.22s-17.13 30.28-16.22 34.22zM216.85 511.34c19.28.44 36.37-18 36.37-18a7 7 0 0 1 1.11 2.38c-5 4.71-19 16.38-34.41 16-19.28-.44-42.07 2.19-42.07 2.19s.09-.29.23-.79a348.85 348.85 0 0 1 38.77-1.78zM251.03 548.15s-.18 2.74-.08 6.85c-4.56 9-12.86 24.52-16.57 25.14l.65-3.6c6.38-8.01 16-28.39 16-28.39z"
  })), React.createElement("path", {
    fill: "url(#prefix__g)",
    d: "M151.35 437.56H256.1v78.94H151.35z"
  }), React.createElement("path", {
    fill: "#fff",
    d: "M154.05 439.59h99.34v74.87h-99.34z"
  }), React.createElement("path", {
    fill: primaryColor,
    opacity: 0.2,
    d: "M163.77 446.07h33.11v18.72h-33.11z"
  }), React.createElement("path", {
    fill: "#e6e8ec",
    d: "M204.8 446.07h38.87v4.32H204.8zM204.8 453.27h27.36v4.32H204.8zM204.8 460.47h38.87v4.32H204.8zM163.77 467.67h79.91v4.32h-79.91zM163.77 474.87h79.91v4.32h-79.91zM163.77 482.06h79.91v4.32h-79.91zM163.77 489.26h73.43v4.32h-73.43zM163.77 496.46h79.91v4.32h-79.91zM163.77 503.66h79.91v4.32h-79.91z"
  }), React.createElement("path", {
    d: "M238.76 543.77l9.31 2 7.34 1.51-3.94-11-2.74-.69-4.27-1.06s-6.13-30.65-18.4-28.45 12.7 37.69 12.7 37.69z",
    fill: "#714b4f"
  }), React.createElement("path", {
    d: "M248.07 545.73l7.34 1.55-3.94-11-2.74-.69a43.77 43.77 0 0 0-.66 10.14z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M320.71 473.66s-10.52 35.5-16.65 39.88-43.38 26.73-54.34 21.47c0 0-2.63 13.15 1.31 16.21 0 0 40.86-1.6 41.19-1.75 0 0 26.73-3.51 31.11-16.65s9.64-35.5 9.64-35.5z",
    fill: "#67647e"
  }), React.createElement("path", {
    d: "M307.56 416.69s.89 3.43 2.08 8.42a23.65 23.65 0 0 1-26.12 12c1.05-4.5.82-9-2.26-12.57z",
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 289.16,
    cy: 413.19,
    r: 23.66,
    fill: "#714b4f"
  }), React.createElement("path", {
    d: "M268.61 406.67a12.67 12.67 0 0 1-5.28.32c-3.69-.76-6.32-4.51-6.41-8.28a12.72 12.72 0 0 1 4.88-9.77c2-1.67 4.4-2.86 6.23-4.72 2.17-2.21 3.35-5.19 5-7.79a23.13 23.13 0 0 1 11.88-9.24c3.63-1.23 8.07-1.37 10.86 1.27 1.43 1.35 2.27 3.3 3.87 4.44 2.32 1.65 5.46 1.16 8.29 1.49a15.8 15.8 0 0 1 11.91 8.92 22.32 22.32 0 0 1 1.16 15.16c-.55 2.15-1.35 4.24-1.94 6.38-1.23 4.46-1.52 9.14-2.94 13.54s-4.35 8.7-8.78 10a27.76 27.76 0 0 0-2.82-14.3 4.1 4.1 0 0 0-2-2.22 4.85 4.85 0 0 0-2.41 0 24 24 0 0 1-16-3.24c-1.68-1-4.3-4.51-6.1-4.86-2.27-.41-7 2.36-9.4 2.9z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M268.61 405.79a12.67 12.67 0 0 1-5.28.32c-3.69-.76-6.32-4.51-6.41-8.28a12.72 12.72 0 0 1 4.88-9.77c2-1.67 4.4-2.86 6.23-4.72 2.17-2.21 3.35-5.19 5-7.79a23.13 23.13 0 0 1 11.88-9.24c3.63-1.23 8.07-1.37 10.86 1.27 1.43 1.35 2.27 3.3 3.87 4.44 2.32 1.65 5.46 1.16 8.29 1.49a15.8 15.8 0 0 1 11.91 8.92 22.32 22.32 0 0 1 1.16 15.16c-.55 2.15-1.35 4.24-1.94 6.38-1.23 4.46-1.52 9.14-2.94 13.54s-4.35 8.7-8.78 10a27.76 27.76 0 0 0-2.82-14.3 4.1 4.1 0 0 0-2-2.22 4.85 4.85 0 0 0-2.41 0 24 24 0 0 1-16-3.24c-1.68-1-4.3-4.51-6.1-4.86-2.27-.41-7 2.37-9.4 2.9z",
    fill: "#503f43"
  }), React.createElement("path", {
    d: "M86.17 760.29a11.67 11.67 0 0 0 3.83-5.78c.5-2.3-.48-5.05-2.68-5.89-2.46-.94-5.09.76-7.08 2.49s-4.28 3.69-6.89 3.32a10.48 10.48 0 0 0 3.24-9.81 4.1 4.1 0 0 0-.9-2c-1.37-1.46-3.84-.83-5.48.32-5.2 3.66-6.65 10.72-6.68 17.08-.52-2.29-.08-4.68-.1-7s-.66-5-2.64-6.22a8 8 0 0 0-4-.95c-2.34-.09-4.94.15-6.54 1.86-2 2.12-1.47 5.69.26 8s4.35 3.8 6.77 5.42a15 15 0 0 1 4.84 4.61 4.57 4.57 0 0 1 .36.82h14.63a40.83 40.83 0 0 0 9.06-6.27zM955.17 621.29a11.67 11.67 0 0 0 3.83-5.78c.5-2.3-.48-5.05-2.68-5.89-2.46-.94-5.09.76-7.08 2.49s-4.28 3.69-6.89 3.32a10.48 10.48 0 0 0 3.24-9.81 4.1 4.1 0 0 0-.9-2c-1.37-1.46-3.84-.83-5.48.32-5.2 3.66-6.65 10.72-6.68 17.08-.52-2.29-.08-4.68-.1-7s-.66-5-2.64-6.22a8 8 0 0 0-4-.95c-2.34-.09-4.94.15-6.54 1.86-2 2.12-1.47 5.69.26 8s4.35 3.8 6.77 5.42a15 15 0 0 1 4.84 4.61 4.57 4.57 0 0 1 .36.82h14.65a40.83 40.83 0 0 0 9.04-6.27z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M1141.74 375.81c-2.07-6.06-5.06-13.74-7.42-15.55a2.21 2.21 0 0 0-.47-.29h-.29v-7.49l-5.58.89a53.35 53.35 0 0 1-2-8.29 3.85 3.85 0 0 0 4.19.84c-.09-.15-.17-.31-.25-.47l.25-.11a10.37 10.37 0 0 1-1.35-5.08 18.51 18.51 0 0 1 .77-4.8c1-3.45 2.69-6.67 3.63-10.14a24.64 24.64 0 0 0 .84-6.85 25 25 0 0 0-2.6-11.3 6.6 6.6 0 0 0-2-2.58 25.49 25.49 0 0 0-2.42-1.18 13.07 13.07 0 0 1-3.52-3.51 31.56 31.56 0 0 0-15.25-10.18 8.93 8.93 0 0 0-4.88-.39c-3.75 1-5.11 5.65-8.15 8.09-2.68 2.15-6.36 2.37-9.73 3.09s-6.76 2.15-9.06 4.75a9.83 9.83 0 0 0-2.43 6.55 6.59 6.59 0 0 0 2.68 5.86 8.42 8.42 0 0 0 7.11 1 24.18 24.18 0 0 0 18.31 30.4l.65 1.17a50.08 50.08 0 0 1 4.54 11.85c-5.14 2.91-10.75 5.64-14.14 5.9a23.82 23.82 0 0 1-.74 3.92 21.62 21.62 0 0 1-4.45 8.75c-4.61 5.18-25.34 44.34-25.34 44.34s-.65 1.56-1.72 4.22c-12.87 1.58-33.88 3.86-39.74 2.69l-23-21.88s-7.44 5.68-6.79 12.58l-4.15-3.94s-21.88 16.7 12.67 27.64l52.57 6.1c-5 15.11-9.68 32.7-8.23 42.27h.43a19.88 19.88 0 0 0 3-.23l-.09 1.7-5.06 90.66s-1.15 16.7 14.4 24.18c0 0 19 55.85 11.52 62.19 0 0 .89.47 2.39 1.12l-15.63 13.85s-11.52 2.88-17.85 2.3a4.57 4.57 0 0 0-5.05 3.4c0 .12 0 .24-.06.36V695.32c0 .04 0 .25.07.37v.14q.05.2.13.4l.05.12c.05.13.11.26.18.39v.09c.07.13.15.25.23.38l.07.11q.14.2.31.4l.09.1c.12.14.25.27.38.4l.06.05.43.37.09.07c.16.13.34.25.52.37l.12.08c.19.12.39.24.6.35h.09l.65.32h.09l.76.3.16.06.83.27h.14l.91.24h.07l1 .2h.2l1.08.16h.21l1.22.12c2.37.18 5.56.25 9.25.23s0 .09 0 .14v.45c0 .12 0 .25.07.37v.14q.05.2.13.4l.05.12c.05.13.11.26.18.39v.09c.07.13.15.25.23.38l.07.11q.14.2.31.4l.09.1c.12.14.25.27.38.4l.06.05.43.37.09.07c.16.13.34.25.52.37l.13.08c.19.12.39.24.6.35h.09l.65.32h.09l.76.3.16.06.83.27h.14l.91.24h.07l1 .2h.2l1.08.16h.21l1.22.12c15 1.15 62.76-2.3 62.76-2.3V705.26c.47-2.23 2.77-15.19-5.39-24.77.24-.25.48-.52.7-.8 0 0-6.33-10.94-2.88-14.4s-17.27-63.34-17.27-63.34-10.94-17.27-4.61-36.85-.58-40.88-.58-40.88 15.1-4.49 15.41-23.08v-1.73a6.11 6.11 0 0 0 1 .06 4.47 4.47 0 0 0 .64 0s-2.88-10.36.58-17.85 10.94-.58 17.85-31.09c5-22.08 9.4-47.48 11.45-59.84a31.51 31.51 0 0 0-.91-14.88zm-131.41 64.77l-5.25-5c1.74.72 3.67 1.43 5.83 2.11l19.8 2.3c-8.84.82-17.05 1.26-20.38.6z",
    transform: "translate(-56.59 -55.12)",
    fill: "url(#prefix__h)"
  }), React.createElement("path", {
    d: "M1003.86 382.53s-40.73 5.66-49.22 4l-22.63-21.5s-21.5 16.41 12.45 27.15l63.36 7.35z",
    fill: "#fdc2cc"
  }), React.createElement("path", {
    d: "M1003.86 382.53s-40.73 5.66-49.22 4l-22.63-21.5s-21.5 16.41 12.45 27.15l63.36 7.35z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M1018.57 612.21l-19.8 17.54s-11.31 2.83-17.54 2.26-9.05 9.62 5.66 10.75 61.66-2.26 61.66-2.26 4.53-18.1-9.05-28.29z",
    fill: "#47465a"
  }), React.createElement("path", {
    d: "M1018.57 612.21l-19.8 17.54s-11.31 2.83-17.54 2.26-9.05 9.62 5.66 10.75 61.66-2.26 61.66-2.26 4.53-18.1-9.05-28.29z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M1049.26 632.66a31.2 31.2 0 0 1-.71 6.13s-47 3.39-61.66 2.26c-7.07-.54-10.08-3.18-10.62-5.71-.64 2.9 1.92 6.74 10.62 7.41 14.71 1.13 61.66-2.26 61.66-2.26a32.69 32.69 0 0 0 .71-7.83z",
    fill: "#fff",
    opacity: 0.3
  }), React.createElement("path", {
    d: "M1041.76 291.45s12.45 17.54 7.92 29.42 23.73-12.45 23.73-12.45-9.05-15.84-4.53-32.81z",
    fill: "#fdc2cc"
  }), React.createElement("path", {
    d: "M1038.41 618.99l-19.8 17.54s-11.31 2.83-17.54 2.26-9.05 9.62 5.66 10.75 61.66-2.26 61.66-2.26 4.53-18.1-9.05-28.29z",
    fill: "#47465a"
  }), React.createElement("path", {
    d: "M1044.03 615.03c-2.95 3.64-7.11 5-11.46 5.25-9.89.47-20.78-5.25-20.78-5.25 7.35-6.22-11.31-61.1-11.31-61.1-15.27-7.35-14.14-23.76-14.14-23.76l5-89.07 1.25-22.37 15.84-9.62 12.49 9.58 11.84 9.09a47.6 47.6 0 0 1 1.48 8.83c1.37 20.79-15.06 25.68-15.06 25.68s6.79 20.93.57 40.16 4.53 36.2 4.53 36.2 20.37 58.83 17 62.23 2.75 14.15 2.75 14.15z",
    fill: "#565171"
  }), React.createElement("path", {
    d: "M1044.03 615.03c-2.95 3.64-7.11 5-11.46 5.25-9.89.47-20.78-5.25-20.78-5.25 7.35-6.22-11.31-61.1-11.31-61.1-15.27-7.35-14.14-23.76-14.14-23.76l5-89.07 1.25-22.37 15.84-9.62 12.49 9.58 11.84 9.09a47.6 47.6 0 0 1 1.48 8.83c1.37 20.79-15.06 25.68-15.06 25.68s6.79 20.93.57 40.16 4.53 36.2 4.53 36.2 20.37 58.83 17 62.23 2.75 14.15 2.75 14.15z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M1063.83 621.82c-9.62 11.88-32.24 0-32.24 0a3.6 3.6 0 0 0 1-1.54c4.15-11.28-14-65.21-14-65.21-15.27-7.35-17-24.89-17-24.89l-4-90.65-.52-11.74 23.8-9.09 7.31-2.79 24.33 18.67a44.12 44.12 0 0 1 1.56 11.83c-.31 18.27-15.14 22.68-15.14 22.68s6.79 20.93.57 40.16 4.53 36.2 4.53 36.2 20.37 58.83 17 62.23 2.8 14.14 2.8 14.14z",
    fill: "#565171"
  }), React.createElement("path", {
    d: "M1054.07 446.4c-4.89-.7-14.79-6.59-19.88-9.79l-3.18-2s-5.09-14.14-18.67-3.39a50.82 50.82 0 0 1-14.75 8.34 34.51 34.51 0 0 1-6.3 1.58l1.25-22.37 15.84-9.62 12.49 9.58 7.31-2.79 24.33 18.67a44.12 44.12 0 0 1 1.56 11.79z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M1084.69 337.88c-2 12.14-6.34 37.09-11.25 58.79-6.79 30-14.14 23.19-17.54 30.55s-.57 17.54-.57 17.54c-5.66.57-24.33-11.88-24.33-11.88s-5.09-14.14-18.67-3.39S988 439.67 988 439.67c-2.83-18.67 18.1-68.45 18.1-68.45s20.37-38.47 24.89-43.56a21.24 21.24 0 0 0 4.37-8.6 23.4 23.4 0 0 0 .72-3.85c7.35-.57 25.46-13 25.46-13l14.14-2.26v7.35a2.17 2.17 0 0 1 .46.28c2.33 1.78 5.26 9.33 7.29 15.28a31 31 0 0 1 1.26 15.02z",
    fill: "#f68080"
  }), React.createElement("path", {
    d: "M1073.41 314.65s-14.71-11.88-36.77 26.59-27.15 32.24-27.15 32.24 4.53 17 2.26 20.37c0 0 15.27-1.13 20.93 0s40.73-42.97 40.73-42.97 18.14-24.92 0-36.23z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M1072.88 312.38s-14.71-11.88-36.77 26.59-27.15 32.24-27.15 32.24 17.54 19.23 23.19 20.37 40.73-43 40.73-43 18.1-24.88 0-36.2z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M1011.26 390.17c.23-4.19-1.35-11.56-2.26-15.38 3.44-.45 5.61-.75 5.61-.75l4 17zM1069.48 276.75l-27.15 15.84a58 58 0 0 1 3.16 5.18 23.87 23.87 0 0 0 4.76.48c7.25 0 10.63-7.61 15-12.73-.31-4.11 3.02-4.22 4.23-8.77z",
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 1049.69,
    cy: 273.35,
    r: 23.76,
    fill: "#fdc2cc"
  }), React.createElement("path", {
    fill: "url(#prefix__i)",
    d: "M821.62 300.43h191.35v144.2H821.62z"
  }), React.createElement("path", {
    fill: "#fff",
    d: "M825.91 303.66h182.77V441.4H825.91z"
  }), React.createElement("path", {
    fill: primaryColor,
    opacity: 0.2,
    d: "M843.79 315.58h60.92v34.43h-60.92z"
  }), React.createElement("path", {
    fill: "#e6e8ec",
    d: "M919.28 315.58h71.52v7.95h-71.52zM919.28 328.83h50.33v7.95h-50.33zM919.28 342.07h71.52v7.95h-71.52zM843.79 355.31H990.8v7.95H843.79zM843.79 368.56H990.8v7.95H843.79zM843.79 381.8H990.8v7.95H843.79zM843.79 395.05h135.09V403H843.79zM843.79 408.29H990.8v7.95H843.79zM843.79 421.53H990.8v7.95H843.79z"
  }), React.createElement("path", {
    d: "M1019.63 254.13a16.24 16.24 0 0 1 8.9-4.67c3.3-.71 6.92-.93 9.56-3 3-2.39 4.32-6.93 8-7.94a8.77 8.77 0 0 1 4.79.38 31 31 0 0 1 15 10 12.84 12.84 0 0 0 3.45 3.45 25 25 0 0 1 2.38 1.16 6.48 6.48 0 0 1 1.94 2.53 24.59 24.59 0 0 1 1.72 17.27c-.92 3.41-2.58 6.57-3.56 10s-1.23 7.24.57 10.27c-1.74.89-3.94-.23-5-1.85s-1.42-3.62-2-5.49a21 21 0 0 0-6.13-9.53c-1.78-1.58-5-2.64-6.21-.6-.48.79-.45 1.79-.86 2.61-.81 1.6-3.15 1.92-4.7 1a7.21 7.21 0 0 1-2.94-4.36c-2.33-7.88-6.3-12.84-14.73-9.47-3.14 1.26-6.84 2.11-9.86-.05-3.94-2.85-3.17-8.49-.32-11.71z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M1019.63 253.56a16.24 16.24 0 0 1 8.9-4.67c3.3-.71 6.92-.93 9.56-3 3-2.39 4.32-6.93 8-7.94a8.77 8.77 0 0 1 4.79.38 31 31 0 0 1 15 10 12.84 12.84 0 0 0 3.45 3.45 25 25 0 0 1 2.38 1.16 6.48 6.48 0 0 1 1.94 2.53 24.59 24.59 0 0 1 1.72 17.27c-.92 3.41-2.58 6.57-3.56 10s-1.23 7.24.57 10.27c-1.74.89-3.94-.23-5-1.85s-1.42-3.62-2-5.49a21 21 0 0 0-6.13-9.53c-1.78-1.58-5-2.64-6.21-.6-.48.79-.45 1.79-.86 2.61-.81 1.6-3.15 1.92-4.7 1a7.21 7.21 0 0 1-2.94-4.36c-2.33-7.88-6.3-12.84-14.73-9.47-3.14 1.26-6.84 2.11-9.86-.05-3.94-2.85-3.17-8.48-.32-11.71z",
    fill: "#b96b6b"
  }), React.createElement("path", {
    d: "M1076.17 307.58h-11.5s-22.63 11.31-23.19 10.75c-.38-.38-3.88.27-6.1.74a23.4 23.4 0 0 0 .72-3.85c7.35-.57 25.46-13 25.46-13l14.14-2.26v7.35a2.17 2.17 0 0 1 .47.27z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M1069.06 639.45a31.2 31.2 0 0 1-.71 6.13s-47 3.39-61.66 2.26c-7.07-.54-10.08-3.18-10.62-5.71-.64 2.9 1.92 6.74 10.62 7.41 14.71 1.13 61.66-2.26 61.66-2.26a32.69 32.69 0 0 0 .71-7.83z",
    fill: "#fff",
    opacity: 0.3
  }), React.createElement("g", {
    opacity: 0.05
  }, React.createElement("path", {
    d: "M1006.97 428.88c-7.63 6-14.38 8.51-18.81 9.51 0 .42.08.84.14 1.24 0 0 10.75.57 24.33-10.18a18.23 18.23 0 0 1 7.27-3.8c-2.96-1.37-7.19-1.28-12.93 3.23zM1083.75 322.88c-2-6-5-13.5-7.29-15.28a2.17 2.17 0 0 0-.46-.28s-4.68.16-4.53.28c2.33 1.78 4.59 8.76 6.62 14.71a31 31 0 0 1 1.23 15c-2 12.14-6.34 37.09-11.25 58.79-6.79 30-14.14 23.19-17.54 30.55-2.78 6-1.39 13.94-.79 16.61 2.42 1 4.52 1.63 5.88 1.49 0 0-2.83-10.18.57-17.54s10.75-.57 17.54-30.55c4.91-21.69 9.23-46.65 11.25-58.79a31 31 0 0 0-1.23-14.99z"
  })), React.createElement("path", {
    d: "M1018.57 391.02l-7.31-.85-56-6.51c-33.94-10.75-12.45-27.15-12.45-27.15l22.63 21.5c6.53 1.31 32.13-1.74 43.6-3.21 3.44-.45 5.61-.75 5.61-.75z",
    fill: "#fdc2cc"
  }), React.createElement("path", {
    d: "M1073.41 313.52s-14.71-11.88-36.77 26.59-27.15 32.24-27.15 32.24 4.53 17 2.26 20.37c0 0 15.27-1.13 20.93 0s40.73-43 40.73-43 18.14-24.89 0-36.2z",
    fill: "#f68080"
  }));
};
UndrawInSync.propTypes = {
  height: PropTypes.string,
  primaryColor: PropTypes.string
};
export default UndrawInSync;